export default __webpack_public_path__ + "static/media/contacto1440px.19cbd7cc.jpg";